// v1.0.0 - 2026-01-28 - Member Documents page placeholder

import { PageContainer, PageHeader } from '@/components/layout/PageContainer'
import { Card, CardContent } from '@/components/ui/card'

export default function MemberDocuments() {
  return (
    <PageContainer>
      <PageHeader
        title="Documenti"
        description="Attestati e certificazioni"
      />
      <Card>
        <CardContent className="py-12 text-center text-[var(--color-text-secondary)]">
          Documenti in arrivo (Sprint 5)
        </CardContent>
      </Card>
    </PageContainer>
  )
}
